import React from 'react';
import { Route, useLocation, useParams } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import { initiativeTypes } from '../constants';

import InitiativeShowBase from '../pages/initiatives/show';
import InitiativeNewBase from '../pages/initiatives/new';
import InitiativePreviewBase from '../pages/initiatives/preview';
import InitiativeEditBase from '../pages/initiatives/edit';
import InitiativeFilesBase from '../pages/initiatives/files';

// Wrapper to inject initiativeType from URL path
const createInitiativeWrapper = (BaseComponent) => {
  return () => {
    const location = useLocation();
    const params = useParams();

    const pathSegments = location.pathname.split('/').filter(Boolean);
    const initiativeType = pathSegments.find((segment) =>
      initiativeTypes.includes(segment)
    );

    return <BaseComponent {...params} initiativeType={initiativeType} />;
  };
};

const InitiativeShow = createInitiativeWrapper(InitiativeShowBase);
const InitiativeNew = createInitiativeWrapper(InitiativeNewBase);
const InitiativePreview = createInitiativeWrapper(InitiativePreviewBase);
const InitiativeEdit = createInitiativeWrapper(InitiativeEditBase);
const InitiativeFiles = createInitiativeWrapper(InitiativeFilesBase);

export const initiativeRoutes = () => {
  return initiativeTypes.map((type) => (
    <React.Fragment key={type}>
      <Route
        path={ROUTES.INITIATIVES_NEW.replace(':initiativeType', type)}
        element={<InitiativeNew />}
      />
      <Route
        path={ROUTES.INITIATIVES_SHOW.replace(':initiativeType', type)}
        element={<InitiativeShow />}
      />
      <Route
        path={ROUTES.INITIATIVES_PREVIEW.replace(':initiativeType', type)}
        element={<InitiativePreview />}
      />
      <Route
        path={ROUTES.INITIATIVES_EDIT.replace(':initiativeType', type)}
        element={<InitiativeEdit />}
      />
      <Route
        path={ROUTES.INITIATIVES_FILES.replace(':initiativeType', type)}
        element={<InitiativeFiles />}
      />
    </React.Fragment>
  ));
};
